import React , {Suspense} from 'react';
import ReactDOM from 'react-dom/client';

import Loader from './components/Loader'

// Store
import {store, sagaMiddleware} from './store/store'
import { Provider } from 'react-redux'
import rootSaga from './sagas/root';

import {
  BrowserRouter as Router,
} from 'react-router-dom'

import './styles.scss'
import App from './components/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import { MatomoProvider, createInstance } from '@jonkoops/matomo-tracker-react'


const instance = createInstance({
  urlBase: 'https://webstats.fh-potsdam.de/',
  siteId: 14,
  // userId: '', // optional, default value: `undefined`.
  // trackerUrl: 'https://LINK.TO.DOMAIN/tracking.php', // optional, default value: `${urlBase}matomo.php`
  // srcUrl: 'https://LINK.TO.DOMAIN/tracking.js', // optional, default value: `${urlBase}matomo.js`
  disabled: false, // Makes all tracking calls no-ops if set to true.
  heartBeat: { // optional, enabled by default
    active: true, // optional, default value: true
    seconds: 10 // optional, default value: `15
  },
  linkTracking: true, // optional, default value: true
  configurations: { // optional, default value: {}
    // any valid matomo configuration, all below are optional
    // disableCookies: true,
    // setSecureCookie: true,
    // setRequestMethod: 'POST',
    trackPageView: true,
  }
})

const root = ReactDOM.createRoot(document.getElementById('fhp-vvz'));
// run root saga after config has been set
sagaMiddleware.run(rootSaga);

root.render(
  <React.StrictMode>
    <MatomoProvider value={instance}>
      <Provider store={store}>
        <Suspense fallback={<Loader/>}>
          <Router>
            <App />
          </Router>
        </Suspense>
      </Provider>
    </MatomoProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
